import ProductDetailsList from './ProductDetailsList'

export default ProductDetailsList
